import axios from 'axios'

const xmlCommunicationRequest = (host, channelId, webcastId) => {

  return axios.post(`${host}/service/channel/xml/previewcommunicationfeed`,
    `<request>
      <channel id="${channelId}">
          <communication id="${webcastId}"/>
      </channel>
    </request>`,
    {
      headers: {
        'Content-Type': 'text/xml',
        'cache-control': 'no-cache'
      }
    })

}

export default xmlCommunicationRequest
